import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTempoAtivo } from './TempoAtivoContext';

// Widget flutuante do tempo do BPO: enquanto houver relógio correndo (empresa
// ligada ou cronômetro de tarefa), uma pill fixa no canto inferior direito
// acompanha o usuário em QUALQUER página. Clicar leva de volta à empresa;
// o botão para o relógio dali mesmo.

const hms = (s) =>
  `${String(Math.floor(s / 3600)).padStart(2, '0')}:${String(Math.floor((s % 3600) / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;

const TempoFlutuante = () => {
  const { relogios, buscadoEm, pararRelogio } = useTempoAtivo();
  const location = useLocation();
  const navigate = useNavigate();
  const [agora, setAgora] = useState(Date.now());
  const [parando, setParando] = useState(null);   // chave do relógio sendo parado

  // tique de 1s só enquanto houver relógio na tela
  useEffect(() => {
    if (!relogios.length) return undefined;
    const t = setInterval(() => setAgora(Date.now()), 1000);
    return () => clearInterval(t);
  }, [relogios.length]);

  // a página da própria empresa já mostra o relógio — o widget sai da frente
  const empresaAberta = new URLSearchParams(location.search).get('empresa');
  const visiveis = relogios.filter((r) =>
    !(location.pathname === `/BpoTarefas/${r.area}` && empresaAberta === r.empresa));

  if (!visiveis.length) return null;

  const segundosDe = (r) =>
    r.segundos + Math.max(r.cronometro_seg || 0, 0)
    + Math.max(Math.floor((agora - buscadoEm) / 1000), 0);

  const chaveDe = (r) => `${r.tipo}-${r.area}-${r.tipo === 'tarefa' ? r.tarefa_id : r.empresa}`;

  const parar = (ev, r) => {
    ev.stopPropagation();
    setParando(chaveDe(r));
    pararRelogio(r).finally(() => setParando(null));
  };

  return (
    <div style={{
      position: 'fixed', bottom: '16px', right: '16px', zIndex: 9000,
      display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'flex-end',
    }}>
      {visiveis.map((r) => (
        <div key={chaveDe(r)}
          onClick={() => navigate(`/BpoTarefas/${r.area}?empresa=${encodeURIComponent(r.empresa)}`)}
          title={`${r.area === 'FIN' ? 'BPO Financeiro' : 'BPO RH'} — clique para abrir ${r.empresa}`}
          style={{
            display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer',
            padding: '8px 12px', borderRadius: '999px',
            backgroundColor: '#e6f7ef', color: '#116b47',
            border: '1.5px solid #1fa971',
            boxShadow: '0 4px 14px rgba(0, 32, 91, 0.25)',
            fontSize: '.9rem', maxWidth: '360px',
          }}>
          <i className="fas fa-stopwatch"></i>
          <span style={{ minWidth: 0 }}>
            <span className="fw-bold" style={{
              display: 'block', whiteSpace: 'nowrap', overflow: 'hidden',
              textOverflow: 'ellipsis', maxWidth: '210px', color: '#00205b',
            }}>
              {r.empresa}
            </span>
            {r.tipo === 'tarefa' && (
              <span style={{
                display: 'block', whiteSpace: 'nowrap', overflow: 'hidden',
                textOverflow: 'ellipsis', maxWidth: '210px', fontSize: '.75rem',
              }}>
                na tarefa: {r.tarefa}
              </span>
            )}
          </span>
          <span className="fw-bold" style={{ fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>
            {hms(segundosDe(r))}
          </span>
          <button className="btn btn-sm p-0 border-0"
            onClick={(ev) => parar(ev, r)}
            disabled={parando === chaveDe(r)}
            title={r.tipo === 'tarefa'
              ? 'Parar o cronômetro da tarefa (o tempo volta a contar para o cliente)'
              : 'Parar o tempo neste cliente'}
            style={{
              width: '26px', height: '26px', borderRadius: '50%', flexShrink: 0,
              backgroundColor: '#dc3545', color: '#fff',
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            }}>
            {parando === chaveDe(r)
              ? <span className="spinner-border spinner-border-sm" style={{ width: '12px', height: '12px' }}></span>
              : <i className="fas fa-stop" style={{ fontSize: '.65rem' }}></i>}
          </button>
        </div>
      ))}
    </div>
  );
};

export default TempoFlutuante;
